import { useEffect } from "react";
import IntroductionWithImagesSection from "../components/AboutUs/IntroductionWithImagesSection";
import ContactsSection from "../components/Contacts/ContactsSection";
import DescriptionWithImageSection from "../components/Common/DescriptionWithImage";
import { useI18n } from "../i18n/I18nContext";

const AboutUs = () => {
  const { copy } = useI18n();
  const aboutCopy = copy.about;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <div>
      <DescriptionWithImageSection
        title={
          <h2>
            {aboutCopy.titleBefore}
            <br />{" "}
            <span style={{ color: "#0668E1" }}>
              {aboutCopy.titleHighlight}
            </span>
          </h2>
        }
        paragraph={
          <p>
            {aboutCopy.introBefore}
            <span style={{ color: "#0668E1" }}>
              {aboutCopy.introHighlight}
            </span>
            {aboutCopy.introAfter}
            <br />
            <br />
            {aboutCopy.companyPrefix}
            <span style={{ color: "#0668E1" }}>Warenex</span>
            {aboutCopy.companySuffix}
          </p>
        }
        showButton={false}
        imageInfo={{
          link: "/about_us_header.webp",
          description: aboutCopy.imageAlt,
        }}
      />
      <IntroductionWithImagesSection />
      <ContactsSection />
    </div>
  );
};

export default AboutUs;
